import { Tabs, TabsProps } from '@mui/material';
import React from 'react';

export type JumpNavProps = TabsProps;

export const JumpNav: React.FC<JumpNavProps> = ({ indicatorColor = 'primary', ...props }) => (
  <Tabs indicatorColor={indicatorColor} {...props}>
    {props.children}
  </Tabs>
);
